import { Component, OnInit, Inject, ViewChild, AfterViewInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NeoVisComponent } from './neovis-graph.component';
@Component({
  selector: 'app-neovis-modal',
  template: `
    <div style="position: relative;">
      <button mat-icon-button (click)="close()" style="position: absolute; right: 8px; top: 0px;">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <div mat-dialog-title>
      <img src="assets/images/immersion_assets/Logo_Immersion1.png" style="width: 120px; height: auto;" />
    </div>
    <div>
      <app-neovis [element]="element" [showConsulta]="showConsulta"></app-neovis>
    </div>
  `,
  styleUrls: []
})
export class NeovisModalComponent implements OnInit, AfterViewInit {
  element: any;
  showConsulta: boolean = false;
  @ViewChild(NeoVisComponent) neovis: NeoVisComponent;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<NeovisModalComponent>
  ) {
    console.log("RECEIVING DATA", data);
    if (data) {
      this.element = data.element;
      this.showConsulta = true;
    }
  }

  ngOnInit(): void {

  }

  ngAfterViewInit() {
    this.neovis.element = this.element
    this.neovis.initNeovis();
  }

  close() {
    this.dialogRef.close();
  }

}